import styled from "styled-components";


export const Container = styled.main`
width: min(1800px, 100% - 2rem);
margin: 0 auto;
  position: relative;
  z-index: 0;
  padding: 0 10rem;
  overflow: hidden;
    gap: 4rem;
  display: flex;
  flex-direction: column;

  #tsparticles{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  @media (max-width: 740px){
    padding: 0 4rem;
  }

  @media(max-width: 360px){
    padding: 0 2rem;
  }
`